var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHub = function SvgHub(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8C18 4.68629 20.6863 2 24 2C27.3137 2 30 4.68629 30 8C30 11.3137 27.3137 14 24 14C20.6863 14 18 11.3137 18 8ZM24 6C22.8954 6 22 6.89543 22 8C22 9.10457 22.8954 10 24 10C25.1046 10 26 9.10457 26 8C26 6.89543 25.1046 6 24 6Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 40C18 36.6863 20.6863 34 24 34C27.3137 34 30 36.6863 30 40C30 43.3137 27.3137 46 24 46C20.6863 46 18 43.3137 18 40ZM24 38C22.8954 38 22 38.8954 22 40C22 41.1046 22.8954 42 24 42C25.1046 42 26 41.1046 26 40C26 38.8954 25.1046 38 24 38Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 40C34 36.6863 36.6863 34 40 34C43.3137 34 46 36.6863 46 40C46 43.3137 43.3137 46 40 46C36.6863 46 34 43.3137 34 40ZM40 38C38.8954 38 38 38.8954 38 40C38 41.1046 38.8954 42 40 42C41.1046 42 42 41.1046 42 40C42 38.8954 41.1046 38 40 38Z",
    fill: "#0258FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 40C2 36.6863 4.68629 34 8 34C11.3137 34 14 36.6863 14 40C14 43.3137 11.3137 46 8 46C4.68629 46 2 43.3137 2 40ZM8 38C6.89543 38 6 38.8954 6 40C6 41.1046 6.89543 42 8 42C9.10457 42 10 41.1046 10 40C10 38.8954 9.10457 38 8 38Z",
    fill: "#0258FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2978 19.1273C23.7505 18.9576 24.2495 18.9576 24.7022 19.1273L38.7556 24.3974C40.7071 25.1292 42 26.9948 42 29.079V36C42 37.1046 41.1046 38 40 38C38.8954 38 38 37.1046 38 36V29.079C38 28.6622 37.7414 28.289 37.3511 28.1427L24 23.136L10.6489 28.1427C10.2586 28.289 10 28.6622 10 29.079V36C10 37.1046 9.10457 38 8 38C6.89543 38 6 37.1046 6 36V29.079C6 26.9948 7.29286 25.1292 9.24438 24.3974L23.2978 19.1273Z",
    fill: "#0258FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 10V38H22V10H26Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hub.9674f674.svg";
export { ForwardRef as ReactComponent };